import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
    },
    paperRoot: {
      marginTop: 32,
      paddingBottom: theme.spacing(2),
    },
    gridContainer: {
      padding: theme.spacing(2),
    },
    chip: {
      margin: theme.spacing(0.5),
      marginBottom: 10,
      fontSize: 14,
      fontWeight: 550,
    },
    chipContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      padding: 0,
      paddingRight: theme.spacing(2),
    },
    chipAdd: {
      margin: theme.spacing(0.5),
      marginBottom: 10,
      fontSize: 14,
      fontWeight: 550,
      border: ' 2px dashed #14171A !important',
      '& span': {
        color: '#14171A',
      },
      cursor: 'pointer',
    },
    deleteIcon: {
      width: 16,
      height: 16,
      background: ' #14171A',
      color: '#fff',
      borderRadius: '50%',

      '&:hover': {
        color: '#fff',
      },
    },
    icons: {
      display: 'flex',
      alignItems: 'center',
    },
    scopeFilter: {
      marginLeft: theme.spacing(2),
    },
    label: {
      margin: theme.spacing(1),
      marginRight: 0,
      fontSize: theme.spacing(2),
      color: 'rgba(0, 0, 0, 0.54)',
    },

    chipLabel: {
      fontSize: theme.spacing(2),
      fontWeight: 500,
      color: theme.palette.colors.blue,
    },
    chipRoot: {
      minWidth: 150,
      justifyContent: 'space-between',
    },
    contentDilogueExport: {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      margin: '0px 8px 16px 0px',
    },
    addButton: {
      background: '#0094FF',
      borderRadius: 12,
      color: '#fff',
      minHeight: 40,
      padding: '0px 16px',
      '&:hover': {
        background: '#0094FF',
        filter: 'brightness(0.9)',
      },
    },
  }),
);

export default useStyles;
